import type { ResourceQuery } from 'infrastructure/api'
import { doAdminQueries } from 'infrastructure/api'
import { atom } from 'jotai/index'
import { atomWithRefresh } from 'infrastructure/state/atomWithRefresh'

const queryKey = 'demo'

type DemoResponse = {
  id: number
  uuid: string
  school_id: number
  message_id: number
  school_name: string
  date_created: string
  date_deleted?: string
  token_duration_days: number
  message: string
  expiration_date: string
  demo_type: string
}

async function fetchDemo(id: number) {
  const resourceData: ResourceQuery = {
    key: queryKey,
    fields: [
      'uuid',
      'id',
      'school_id',
      'school_name',
      'token_duration_days',
      'date_created',
      'date_deleted',
      'message_id',
      'message',
      'expiration_date',
      'demo_type',
    ],
  }
  const params = { id }
  const response = await doAdminQueries<DemoResponse>(
    [{ resourceData, params }],
    false,
  )
  return response.data?.[queryKey]
}

export const demoIdAtom = atom<number | undefined>(undefined)

export const demoResponseAtom = atomWithRefresh(async (get) => {
  const demoId = get(demoIdAtom)
  if (!demoId) return
  return fetchDemo(demoId)
})
